export const isEmptyOrUndefined = (value: any): boolean => {
  if (!value) return true;
  if (value === undefined) return true;
  if (value === 'undefined') return true;
  if (value === '') return true;

  return false;
};
